import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import cx from 'classnames'
import { handleKeyDown } from 'src/utils/helpers'

import { Text, Stack, Box, Flex, Center } from '@chakra-ui/react'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon/index'

import { getTag } from 'src/modules/Documents/helper'
import styles from 'src/modules/Documents/styles.module.less'
import stylesCard from './styles.module.less'
import intlMessages from 'src/modules/Documents/translations'

const PolicyCard = ({ policy, intl, history, onPolicyOpen, styleVariation, language }) => {
  // Redirect to changepolicy if policy not found
  if (!policy && history) {
    history.push('/changepolicy')
    return false
  }

  const handleClick = e => {
    e.preventDefault()

    // For first part of full we use this same component but without "onPolicyOpen"
    if (typeof onPolicyOpen === 'function') {
      onPolicyOpen(policy)
    }
  }

  const label = policy.hasOwnProperty('label') && policy.label.length > 0 ? policy.label : ''

  // When used in full view
  const inFullView = styleVariation && styleVariation === 'full-view'

  const classNames = cx({
    [styles.cardLayout]: true,
    [styles.cardLayoutStyleVariationFullView]: inFullView,
    [styles.cardLayoutStyleVariationSingleView]: !inFullView,
  })

  const classNamesDates = cx({
    [styles.dates]: true,
    [styles.datesEnglish]: language === 'en',
  })

  // effective and renewal fields used on changepolicy page
  const dateEffective = policy.dateEffective || policy.effective
  const expiry = policy.dateExpiry || policy.renewal
  return (
    <Stack className={classNames}>
      <Stack
        onClick={handleClick}
        tabIndex='0'
        onKeyDown={handleKeyDown(handleClick)}
        className={styles.card + ' ' + styles.policyCard}
      >
        <Flex align={'center'}>
          <Flex
            className={styles.topLeft}
            direction={'row'}
            justify={'space-between'}
            align={'center'}
          >
            <Flex align={'center'}>
              {policy.category === 'auto' || policy.category === 'property' ? (
                <Flex align={'center'} mr={'10px'}>
                  {policy.category === 'auto' && (
                    <FontAwesomeIconComponent icon={['far', 'car']} size='xs' type='card-font' />
                  )}
                  {policy.category === 'property' && (
                    <FontAwesomeIconComponent icon={['far', 'house']} size='xs' type='card-font' />
                  )}
                  {(policy.category === 'other' ||
                    (policy.category && (policy.category + '').toLowerCase === 'marine')) && (
                    <FontAwesomeIconComponent icon={['far', 'memo']} size='xs' type='card-font' />
                  )}
                  <Text variant='card' ml={'5px'} fontSize={'14px'} fontWeight={'bold'}>
                    {policy.countPolicyItems}
                  </Text>
                </Flex>
              ) : (
                ''
              )}
              {policy.category === 'auto' ||
              (policy.category === 'property' && policy.countPolicyPeople > 0) ? (
                <Flex align={'center'}>
                  <FontAwesomeIconComponent icon={['far', 'user']} size='xs' type='card-font' />
                  <Text variant='card' ml={'5px'} fontSize={'14px'} fontWeight={'bold'}>
                    {policy.countPolicyPeople}
                  </Text>
                </Flex>
              ) : (
                ''
              )}
            </Flex>
            {policy.tag && (
              <Box className={`${styles.tags} ${styles[policy.tag]}`}>
                {getTag(policy.tag, intl)}
              </Box>
            )}
          </Flex>
        </Flex>
        <Flex mt={'15px'} direction={'column'} justify={'center'} align={'center'}>
          <Text
            variant='card'
            opacity={0.7}
            align={'center'}
            fontSize={'14px'}
            textTransform={'uppercase'}
          >
            {policy.policyNumber}
          </Text>
          <Text
            width={'100%'}
            textAlign={'center'}
            variant='card'
            mt={'5px'}
            align={'center'}
            fontSize={'22px'}
            fontWeight={'bold'}
          >
            {label}
          </Text>

          <Text variant='card' mt={'15px'} opacity={0.5} fontSize={'14px'}>
            {intl.formatMessage(intlMessages.policyInsurer)}
          </Text>
          <Text
            variant='card'
            fontWeight={'bold'}
            fontSize={'18px'}
            textTransform={'uppercase'}
            className={stylesCard.insurerName}
          >
            {policy.insurer}
          </Text>
        </Flex>

        <Flex
          gap={language === 'fr' && !inFullView ? '10px' : '0'}
          direction={language === 'fr' && !inFullView ? 'column' : 'row'}
          align={'center'}
          justify={'space-between'}
          className={classNamesDates}
        >
          <Flex
            direction={'column'}
            justify={'center'}
            align={'center'}
            className={styles.date + ' ' + styles.dateEffective}
          >
            <Flex direction={'row'} align={'center'} opacity={0.5}>
              <Flex>
                <FontAwesomeIconComponent
                  icon={['far', 'calendar-check']}
                  size='xs'
                  type='card-font'
                />
              </Flex>
              <Text variant='card' mx={'5px'} fontSize={'14px'}>
                {intl.formatMessage(intlMessages.policyDateEffective)}
              </Text>
            </Flex>
            <Center>
              <Text
                variant='card'
                fontWeight={'bold'}
                opacity={0.6}
                textTransform={'uppercase'}
                fontSize={'14px'}
              >
                {dateEffective || 'AUG 03.2023'}
              </Text>
            </Center>
          </Flex>
          <Flex
            justify={'center'}
            align={'center'}
            className={styles.date + ' ' + styles.dateExpiry}
          >
            <Flex direction={'row'} align={'center'} opacity={0.5}>
              <Flex>
                <FontAwesomeIconComponent
                  icon={['far', 'calendar-xmark']}
                  size='xs'
                  type='card-font'
                />
              </Flex>
              <Text variant='card' mx={'5px'} fontSize={'14px'}>
                {intl.formatMessage(intlMessages.policyDateExpiry)}
              </Text>
            </Flex>
            <Center>
              <Text
                variant='card'
                fontWeight={'bold'}
                opacity={0.6}
                textTransform={'uppercase'}
                fontSize={'14px'}
              >
                {expiry || 'AUG 03.2023'}
              </Text>
            </Center>
          </Flex>
        </Flex>
      </Stack>
    </Stack>
  )
}

PolicyCard.propTypes = {
  policy: PropTypes.object,
}

export default injectIntl(PolicyCard)
